import { TFunction } from 'i18next';
import { AiMessageFeedbackReasonEnum } from 'graphql-common';
import Input from '@lib/components/Input/Input';
import { InputTypes } from '@lib/components/Input/enums';
import RadioButtonGroup from '@lib/components/RadioButtonGroup/RadioButtonGroup';
import { FieldItem } from '@lib/interfaces/form';
import {
  getFieldValidation,
  getOptionValidation,
} from '@lib/utils/validationUtils';

export const REASON_FIELD = 'reason';
export const COMMENT_FIELD = 'comment';

// The four BE-accepted dislike reasons, in Figma order.
const REASON_OPTIONS: {
  value: AiMessageFeedbackReasonEnum;
  labelKey: string;
}[] = [
  {
    value: AiMessageFeedbackReasonEnum.NotRelevant,
    labelKey: 'ai-feedback-reason-not-relevant',
  },
  {
    value: AiMessageFeedbackReasonEnum.Incorrect,
    labelKey: 'ai-feedback-reason-incorrect',
  },
  {
    value: AiMessageFeedbackReasonEnum.Outdated,
    labelKey: 'ai-feedback-reason-outdated',
  },
  {
    value: AiMessageFeedbackReasonEnum.Other,
    labelKey: 'ai-feedback-reason-other',
  },
];

export default function getFeedbackFields(
  t: TFunction<'translation', undefined>,
): FieldItem[] {
  return [
    {
      name: REASON_FIELD,
      label: t('ai-feedback-question'),
      element: RadioButtonGroup,
      componentProps: {
        options: REASON_OPTIONS.map(({ value, labelKey }) => ({
          value,
          label: t(labelKey),
        })),
      },
      validation: getOptionValidation({ t, required: true }),
    },
    {
      name: COMMENT_FIELD,
      element: Input,
      componentProps: {
        type: InputTypes.textarea,
        label: t('ai-feedback-comment-placeholder'),
      },
      // The BE hard-requires a comment when reason is Other; mirror it
      // client-side so the user sees an inline error instead of a raw
      // server validation failure.
      validation: getFieldValidation({ t }).when(
        REASON_FIELD,
        (deps, schema) =>
          (deps[0] as { value?: AiMessageFeedbackReasonEnum } | null)?.value ===
          AiMessageFeedbackReasonEnum.Other
            ? schema.required(t('required-field-error'))
            : schema,
      ),
    },
  ];
}
